const Reflux = require('@muzzylane/reflux');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

const AccountActions = Reflux.createActions({
    updateAccountInfo: { children: ["completed","failed"] },
    updateThirdPartyUserAccountInfo: { children: ["completed","failed"] },
    getUserSettings: { children: ['completed', 'failed'] },
    updateUserSettings: { children: ['completed', 'failed'] },
    updateAvatar: { children: ["completed","failed"] },
    updateUserPersistentData: { children: ["completed","failed"] },
});

AccountActions.updateAccountInfo.listen(function(actionID, params) {
    const self = this;
    if (!params.userId) {
        this.failed(actionID, params.userId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    let updatedInfo = {};
    if (!!params.displayName) {
        updatedInfo.display_name = params.displayName;
    }

    if (!!params.firstName) {
        updatedInfo.first_name = params.firstName;
    }

    if (!!params.lastName) {
        updatedInfo.last_name = params.lastName;
    }

    if (!!params.password) {
        updatedInfo.password = params.password;
    }

    if (!!params.avatar_name) {
        updatedInfo.avatar_name = params.avatar_name;
    }

    if (!!params.avatar_hash) {
        updatedInfo.avatar_hash = params.avatar_hash;
    }

    updatedInfo.affiliation = params.affiliation || "";

    ServerRequest.makeRequest(`/authoring/user/${params.userId}/update`, 'PUT', JSON.stringify(updatedInfo))
        .then((res) => {
            self.completed(actionID, params.userId, res);
            if (params.callback) {
                params.callback(true);
            }
        })
        .catch((err) => {
            self.failed(actionID, params.userId, err);
            if (params.callback) {
                params.callback(false);
            }
        });
});

AccountActions.updateThirdPartyUserAccountInfo.listen(function(actionID, params) {
    const self = this;
    if (!params.userId) {
        this.failed(actionID, params.userId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    let updatedInfo = {};
    if (!!params.displayName) {
        updatedInfo.display_name = params.displayName;
    }

    if (!!params.firstName) {
        updatedInfo.first_name = params.firstName;
    }

    if (!!params.lastName) {
        updatedInfo.last_name = params.lastName;
    }

    ServerRequest.makeRequest(`/authoring/third_party_user/${params.userId}/update`, 'PUT', JSON.stringify(updatedInfo))
        .then(res => self.completed(actionID, params.userId, res))
        .catch(err => self.failed(actionID, params.userId, err));
});




AccountActions.getUserSettings.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/users/${params.userId}/settings`, 'GET')
        .then(res => self.completed(actionId, res))
        .catch(err => self.failed(actionId, err));
});

AccountActions.updateUserSettings.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/users/${params.userId}/settings`, 'PATCH', JSON.stringify({
            enableCommentsEmail: params.enableCommentsEmail,
            enableShareLinks: params.enableShareLinks,
            enableStudentFeedback: params.enableStudentFeedback,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

AccountActions.updateAvatar.listen(function(actionID, params) {
    const self = this;
    if (!params.userId) {
        this.failed(actionID, params.userId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    let updatedInfo = {};
    if (!!params.avatar_name) {
        updatedInfo.avatar_name = params.avatar_name;
    }

    if (!!params.avatar_hash) {
        updatedInfo.avatar_hash = params.avatar_hash;
    }

    ServerRequest.makeRequest(`/authoring/user/${params.userId}/update_avatar`, 'PUT', JSON.stringify(updatedInfo))
        .then((res) => {
            self.completed(actionID, params.userId, res);
            if (params.callback) {
                params.callback(true);
            }
        })
        .catch((err) => {
            self.failed(actionID, params.userId, err);
            if (params.callback) {
                params.callback(false);
            }
        });
});

AccountActions.updateUserPersistentData.listen(function(actionID, params) {
    const self = this;
    if (!params.userId) {
        this.failed(actionID, params.userId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    if (typeof params.persistentData !== 'object') {
        this.failed(actionID, params.userId, new ForgeError({message: ErrorConsts.MISSING_PARAMS}));
        return;
    }

    let data = { persistentData: params.persistentData }

    ServerRequest.makeRequest(`/authoring/user/${params.userId}/update_persistent_data`, 'PUT', JSON.stringify(data))
        .then((res) => {
            self.completed(actionID, params.userId, res);
            if (params.callback) {
                params.callback(true);
            }
        })
        .catch((err) => {
            self.failed(actionID, params.userId, err);
            if (params.callback) {
                params.callback(false);
            }
        });
});




module.exports = AccountActions;